import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@mdi/font/css/materialdesignicons.css";
import Vuetify from "vuetify";
import infiniteScroll from "vue-infinite-scroll";
import Nazgul from "@/services/nazgul";
import hBtn from "@/components/ui/btn";
import hInput from "@/components/h-input";
import hFile from "@/components/h-file";
import hTextarea from "@/components/h-textarea";
import hSelect from "@/components/h-select";
import hIcon from "@/components/h-icon";
import hProgress from "@/components/h-progress";
import eventHub from "@/services/hubs/eventHub";
import hSectionHeader from "@/components/h-section-header";
import apolloClient from "@/services/apolloClient";
import VueApollo from "vue-apollo";

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

import(/* webpackMode: "eager" */ "vuetify/dist/vuetify.min.css");
// creates a global event hub
// https://medium.com/vuejobs/create-a-global-event-bus-in-vue-js-838a5d9ab03a
Vue.prototype.$eventHub = eventHub; // Global event bus
Vue.config.productionTip = true;
Vue.use(Vuetify);
Vue.use(VueApollo);
Vue.use(infiniteScroll);
Vue.component("h-btn", hBtn);
Vue.component("h-input", hInput);
Vue.component("h-select", hSelect);
Vue.component("h-icon", hIcon);
Vue.component("h-file", hFile);
Vue.component("h-textarea", hTextarea);
Vue.component("h-section-header", hSectionHeader);
Vue.component("h-progress", hProgress);
if (process.env.NODE_ENV !== "development") {
  Vue.config.productionTip = true;
  Vue.config.errorHandler = function(err /* vm, info*/) {
    Nazgul.report("error", err.toString());
  };
  window.onerror = function(message, source, lineno, colno, error) {
    //save error and send to server for example.
    let msg = error ? error.stack : message;
    Nazgul.report("error", msg);
    return true;
  };

  window.addEventListener("error", function(e) {
    Nazgul.report("error", e.error.message);
    return false;
  });
}

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount("#app");

router.afterEach(() => {
  setTimeout(() => Nazgul.report("page_enter"), 100);
});

Nazgul.report("page_load", "page_load");
